import { type ClassSessionGroupWithMembershipsRecord, type ClassSessionRecord } from '../../../../models/types';
import { type CalendarValues } from '../../components/addSessions/types';
import {
    type ClassRecordData,
    type ClassRecord,
    type ClassSessionGroup,
    type ClassSessionInfo,
    type ClassStudentGroup
} from '../../context/types';
import {
    type ClassJoinPermission,
    type ClassLevelOptions,
    type ScreenShareResolutions,
    type UnauthUserAccess,
    type WebExpOptions
} from '../../types/adminConfig';
import { type Permission } from '../../types/recordingTypes';

export enum WaitingRoom {
    ON = 'ON',
    OFF = 'OFF'
}

export enum CanJoinBeforeInstructor {
    YES = 'YES',
    NO = 'NO'
}

export enum RequireAuth {
    ON = 'ON',
    OFF = 'OFF'
}

export interface InitialClassFormValues {
    className: string;
    classId: string;
    description: string;
    classPasscode: string;
    courseTemplate: boolean;
    courseTemplateId: string;
    instructorEmails: string[];
    instructor: string;
    additionalInstructors: AdditionalInstructors[];
    status: 'published' | 'draft';
    ltiState: any;
    lmsSyncSettings: any;
    waitingRoom: WaitingRoom;
    canJoinBeforeInstructor: CanJoinBeforeInstructor;
    requireAuth: RequireAuth;
    dates: CalendarValues[];
    classSessions: ClassSessionInfo[];
    classSessionGroups: ClassSessionGroup[];
    classGroups: ClassStudentGroup[];
    contentType: string;
    classOptions: ClassLevelOptions;
    webExperience: WebExpOptions;
    allowVanillaZoom: boolean;
    unauthUserAccess: UnauthUserAccess;
    unauthUserText: string | null;
    classJoinPermission: ClassJoinPermission;
    rosterSelfEnrollment: boolean;
    attendanceGradeTardyScore: number;
    hasAiTa: boolean;
    hasFileAnnotations: boolean;
    hasPresentations: boolean;
    allowNextGenMobile: boolean;
    enablePrivateDiscussion: boolean;
    orgScreenshareRes: ScreenShareResolutions;
    recordingInitialPermission?: Permission;
    recordingsRestrictChatParticipants: boolean;
    hasTelephony: boolean;
    autoJoinWhenSessionActive: boolean;
    allowInstructorAutoJoinPriorMinutes: number;
    allowStudentJoinPriorMinutes: number;
}

export interface MeetingSettings {
    join_before_host: boolean;
    waiting_room: boolean;
    meeting_authentication: boolean;
}

export interface MeetingObj {
    topic: string;
    password: string;
    agenda: string;
    settings: Partial<MeetingSettings>;
    meeting_id?: string;
    class_options?: ClassLevelOptions;
}

export interface AdditionalInstructors {
    email: string;
    user_name: string;
}

export interface ClassSessionGroupPayload {
    class_session_group_uuid: string;
    schedule: any;
    config: any;
}

export interface ClassCreatePayload {
    meeting_obj: MeetingObj;
    class_data: Partial<ClassRecordData>;
    class_options?: ClassLevelOptions;
    parent_id?: number;
    additional_instructors?: AdditionalInstructors[];
    instructor?: string;
    user_uuid?: string | null;
    class_sessions?: Partial<ClassSessionRecord>[];
    class_session_groups?: Partial<ClassSessionGroupWithMembershipsRecord>[];
    status: 'published' | 'draft';
    class_group_ids?: number[];
}

export interface ClassUpdatePayload {
    meeting_obj?: Partial<MeetingObj>;
    class_data?: Partial<ClassRecordData>;
    class_options?: Partial<ClassLevelOptions>;
    additional_instructors?: AdditionalInstructors[];
    user_uuid?: string | null;
    class_sessions?: Partial<ClassSessionRecord>[];
    class_session_groups?: Partial<ClassSessionGroupWithMembershipsRecord>[];
    class_uuid?: string;
    instructor?: string;
}

export interface TemplateRecord extends ClassRecord {}
